import { S3Config } from 'dashboard/models/external-integration';
import { S3Actions, S3ActionType } from 'dashboard/redux/actions/s3';

export interface S3State {
  s3Config: S3Config | null;
}

export const initialS3State: S3State = {
  s3Config: null,
};

export default (state: S3State = initialS3State, action: S3Actions) => {
  switch (action.type) {
    case S3ActionType.SetS3Config: {
      return {
        ...state,
        s3Config: action.payload?.s3Config,
      };
    }
    default:
      return state;
  }
};
